module.exports = __webpack_public_path__ + "img/BastelnImZoo.41789206.jpg";